import React from 'react';
import Tab from '@mui/material/Tab';
import {styleBg} from '../../../common/Models/Validations';
import Tabs from '@mui/material/Tabs';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import PropTypes from 'prop-types';
import TicketList from './TicketList';

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ pt: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function TicketFilterTabs(props) {
  const [value, setValue] = React.useState(0);
  const [refundState, setRefundState] = React.useState('refund_requested');

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <>
      <Tabs
        value={value}
        variant="scrollable"
        scrollButtons="auto"
        onChange={handleChange}
        aria-label="basic tabs example"
        sx={{
          '& .MuiTab-root': {
            minWidth: { xs: 150, sm: 250 },
            px: { xs: 1, sm: 2 },
          },
        }}
      >
        {[
          { label: "COMPLETED", index: 0 },
          { label: "AWAITING PAYMENT", index: 1 },
          { label: "FAILED", index: 2 },
          { label: "REFUNDS", index: 3 },
          { label: "PENDING", index: 4 },
        ].filter(Boolean).map((tab, index) => (
          <Tab
            key={index}
            label={tab.label}
            {...a11yProps(tab.index)}
            sx={{...styleBg(index, value)}}
          />
        ))}
      </Tabs>
      <CustomTabPanel value={value} index={0}>
        <TicketList status={'completed'}/>
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        <TicketList status={'awaiting_payment'}/>
      </CustomTabPanel>
      <CustomTabPanel value={value} index={2}>
        <TicketList status={'failed'}/>
      </CustomTabPanel>
      <CustomTabPanel value={value} index={3}>
        <Box sx={{display: 'flex', justifyContent: 'flex-end', mb: 2}}>
          <FormControl size={'small'} sx={{minWidth: { xs: '100%', sm: 220 }}}>
            <InputLabel id="customer-refund-state-filter-label">Status</InputLabel>
            <Select
              labelId="customer-refund-state-filter-label"
              label="Status"
              value={refundState}
              onChange={(e) => setRefundState(e.target.value)}
            >
              <MenuItem value={'refund_requested'}>Requested</MenuItem>
              <MenuItem value={'refunded'}>Accepted</MenuItem>
              <MenuItem value={'refund_rejected'}>Cancelled</MenuItem>
              <MenuItem value={'expired'}>Expired</MenuItem>
            </Select>
          </FormControl>
        </Box>
        <TicketList status={refundState}/>
      </CustomTabPanel>
      <CustomTabPanel value={value} index={4}>
        <TicketList status={'pending'}/>
      </CustomTabPanel>
    </>
  );
}